import React from 'react';
import { DownloadForOffline } from '@mui/icons-material';
import { TooltipIcon } from 'shared/components/abstract/interactables';

/**
 * @param {Object} props
 * @param {Function} props.onExport
 * @param {boolean} [props.disabled=false]
 * @param {boolean} [props.hidden=false]
 */
export default function ExportButton(props) {
  const {
    onExport,
    disabled = false,
    hidden = false,
  } = props;

  if (hidden) {
    return null;
  }

  return (
    <TooltipIcon
      className="export-button"
      disabled={disabled}
      fontSize="large"
      icon={DownloadForOffline}
      placement="left"
      message="Export table data"
      onClick={onExport}
    />

  );
}
